module.exports = __webpack_public_path__ + "img/2.a2ff5bc3.png";